import React, { useEffect, useRef } from 'react';
import './Background.css';

const Background = ({ state, videoRefs, styleLoading, setStyleLoading }) => {
  useEffect(() => {
    const updateBackground = () => {
      const currentIndex = state.background;
      const selectedBackgrounds = state.lowContrast ? videoRefs.current.slice(4) : videoRefs.current.slice(0, 4);

      videoRefs.current.forEach((video) => {
        if (video) {
          video.style.display = 'none';
          video.pause();
        }
      });

      if (styleLoading) {
        setStyleLoading(false);
        return;
      }

      const currentVideo = selectedBackgrounds[currentIndex];
      if (currentVideo) {
        currentVideo.currentTime = state.savedTime + 0.2; // Adjust time by 0.2 seconds for smoother transition
        currentVideo.style.display = 'block';
        currentVideo.playbackRate = state.reducedMotion ? 0.2 : 1;
        if (state.isPlaying) {
          const playPromise = currentVideo.play();
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                // Playback started
              })
              .catch((error) => {
                console.error('Error playing video:', error);
              });
          }
        }
      }
    };

    updateBackground();
  }, [state.lowContrast, state.background, state.reducedMotion, state.savedTime, state.isPlaying, styleLoading]);

  return (
    <div id="background-container">
      {['surferka', 'powergirl', 'aktywistka', 'tatuazysta', 'surferkalc', 'powergirllc', 'aktywistkalc', 'tatuazystalc'].map((video, index) => (
        <video
          key={video}
          ref={el => videoRefs.current[index] = el}
          className="background-video"
          loop
          muted
        >
          <source src={`/videos/${video}.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ))}
    </div>
  );
};

export default Background;
